import React from "react"
import ContentLoader from "react-content-loader"

const PreloaderDocCard = (props) => (
  <ContentLoader 
    speed={2}
    width={540}
    height={65}
    viewBox="0 0 80% 65"
    backgroundColor="#f3f3f3"
    foregroundColor="#832626"
    {...props}
  >
    <rect x="0" y="50%" width="38%" height="25" rx="10" />
    <rect x="40%" y="50%" width="38%" height="25" rx="10" />
    <rect x="80%" y="50%" width="18%" height="25" rx="10" />
  </ContentLoader>
)

export default PreloaderDocCard;